import React, { memo } from "react";
import { Route, Routes } from "react-router-dom";

import { App } from "../App";
import { useUser } from "../contexts/userContext";
import { AuthPage, Logout } from "../pages/auth";
import { ErrorsPage } from "../pages/errors/ErrorsPage";
import { OnboardingPage } from "../pages/onboarding";
import { PrivateRoutes } from "./PrivateRoutes";

const NestedRoutes: React.FC = memo(() => {
  const { user } = useUser();
  return (
    <Routes>
      <Route path="/" element={<App />}>
        <Route path="callbackSignIn" />
        <Route path="callbackSignOut" />
        <Route path="onboarding" element={<OnboardingPage />} />
        <Route path="error/*" element={<ErrorsPage />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/auth/logout" element={<Logout />} />
        {user ? (
          <>
            <Route index element={<AuthPage />} />
            <Route path="auth/*" element={<AuthPage />} />
            <Route path="/*" element={<PrivateRoutes />} />
          </>
        ) : (
          <>
            <Route path="login" element={<AuthPage />} />
            <Route path="/login" element={<AuthPage />} />
            <Route path="/auth/*" element={<AuthPage />} />
            <Route path="*" element={<AuthPage />} />
          </>
        )}
      </Route>
    </Routes>
  );
});

export { NestedRoutes };
